var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className ? ("ny-title " + _vm.className) : 'ny-title'},[_c('span',{class:_vm.withLine ? 'with-line' : '',on:{"dblclick":_vm.titleClick}},[_vm._v(_vm._s(_vm.title || ""))]),_vm._t("righter")],2)}
var staticRenderFns = []

export { render, staticRenderFns }